// Only registered operations execute. Canvas configuration never uses eval/Function.
const method = (id, label, args, run, hint = '') => ({ id, label, args, run, hint })
function callback(expression) {
  if (expression === 'String') return String
  if (expression === 'Number') return Number
  if (expression === 'Boolean') return Boolean
  const lengthMatch=/^x\.length\s*(>|>=|<|<=)\s*(\d+)$/.exec(expression)
  if(lengthMatch)return value=>{const n=Number(lengthMatch[2]),length=value.length;return lengthMatch[1]==='>'?length>n:lengthMatch[1]==='>='?length>=n:lengthMatch[1]==='<'?length<n:length<=n}
  const match = /^x\s*(\*|\+|-|\/|>=|<=|>|<|===|!==|%)\s*(-?\d+(?:\.\d+)?)$/.exec(expression)
  if (!match) throw new Error('回调支持 x * 2、x > 2 等，或 String / Number / Boolean')
  const n = Number(match[2])
  return x => {
    switch (match[1]) {
      case '*': return x * n
      case '+': return x + n
      case '-': return x - n
      case '/': return x / n
      case '%': return x % n
      case '>': return x > n
      case '<': return x < n
      case '>=': return x >= n
      case '<=': return x <= n
      case '===': return x === n
      case '!==': return x !== n
      default: return x
    }
  }
}
const array = (value, fn) => { if (!Array.isArray(value)) throw new Error('需要 Array，当前输入不是数组'); return fn(value) }
const string = (value, fn) => { if (typeof value !== 'string') throw new Error('需要 String，当前输入不是字符串'); return fn(value) }
export const categories = [
  { name: '原材料', methods: [
    method('source.number','数字',0,v=>v,'数字原料，例如 42、3.14、-10'),
    method('source.string','文字','',v=>v,'文字原料，JSON 字符串需要双引号，例如 "hello"'),
    method('source.date','日期','2026-01-01',v=>v),
    method('source.array','数组',[1,2,3],v=>v),
    method('source.object','键值对',{name:'苹果',count:3},v=>v)
  ] },
  { name: 'Array', methods: [
    {...method('Array.length','length',[],v=>array(v,x=>x.length)),property:true},
    {...method('Array.index','[]',[0],(v,a)=>array(v,x=>x[a[0]])),indexAccess:true},
    method('Array.map','map',['x * 2'],(v,a)=>array(v,x=>x.map(callback(a[0]))),'回调参数示例：["x * 2"]'),
    method('Array.filter','filter',['x > 2'],(v,a)=>array(v,x=>x.filter(callback(a[0]))),'回调参数示例：["x > 2"]'),
    method('Array.slice','slice',[0,3],(v,a)=>array(v,x=>x.slice(...a))),
    method('Array.join','join',[', '],(v,a)=>array(v,x=>x.join(...a))),
    method('Array.concat','concat',[[5,6]],(v,a)=>array(v,x=>x.concat(...a))),
    method('Array.reverse','reverse',[],v=>array(v,x=>x.reverse())),
    method('Array.reduce','reduce',['sum',0],(v,a)=>array(v,x=>x.reduce((acc,n)=>{if(a[0]==='sum')return acc+n;if(a[0]==='product')return acc*n;throw new Error('reduce 支持 sum / product')},a[1])),'["sum",0] 求和；["product",1] 求积'),
    method('Array.includes','includes',[2],(v,a)=>array(v,x=>x.includes(...a)))
  ] },
  { name:'String', methods:[
    {...method('String.length','length',[],v=>string(v,x=>x.length)),property:true},
    method('String.trim','trim',[],v=>string(v,x=>x.trim())),
    method('String.toUpperCase','toUpperCase',[],v=>string(v,x=>x.toUpperCase())),
    method('String.toLowerCase','toLowerCase',[],v=>string(v,x=>x.toLowerCase())),
    method('String.split','split',[','],(v,a)=>string(v,x=>x.split(...a))),
    method('String.slice','slice',[0,5],(v,a)=>string(v,x=>x.slice(...a))),
    method('String.replace','replace',['hello','hi'],(v,a)=>string(v,x=>x.replace(...a))),
    method('String.includes','includes',['a'],(v,a)=>string(v,x=>x.includes(...a)))
  ] },
  { name:'Number', methods:[method('Number','Number',[],v=>Number(v)),method('Number.parseInt','parseInt',[10],(v,a)=>Number.parseInt(v,...a)),method('Number.parseFloat','parseFloat',[],v=>Number.parseFloat(v)),method('Number.isFinite','isFinite',[],v=>Number.isFinite(v)),method('Number.toFixed','toFixed',[2],(v,a)=>{if(typeof v!=='number')throw new Error('toFixed 需要 Number');return v.toFixed(...a)})] },
  { name:'Math', methods:['abs','round','floor','ceil','sqrt'].map(name=>method('Math.'+name,name,[],v=>{if(typeof v!=='number')throw new Error('Math 工位需要 Number');return Math[name](v)})).concat([method('Math.pow','pow',[2],(v,a)=>Math.pow(v,...a)),method('Math.max','max',[],v=>array(v,x=>Math.max(...x))),method('Math.min','min',[],v=>array(v,x=>Math.min(...x)))]) },
  { name:'Date', methods:[method('Date.getUTCFullYear','getUTCFullYear',[],v=>{if(!(v instanceof Date)||Number.isNaN(v.getTime()))throw new Error('需要有效时间物料');return v.getUTCFullYear()})] },
  { name:'Object', methods:['keys','values','entries'].map(name=>method('Object.'+name,name,[],v=>Object[name](v))).concat([method('Object.fromEntries','fromEntries',[],v=>Object.fromEntries(v)),{...method('Object.get','[]',['count'],(v,a)=>v[a[0]]),keyAccess:true}]) },
  { name:'JSON', methods:[method('JSON.stringify','stringify',[],v=>JSON.stringify(v)),method('JSON.parse','parse',[],v=>JSON.parse(v))] },
  { name:'Boolean', methods:[method('Boolean','Boolean',[],v=>Boolean(v))] }
]
const keywords = ['const','let','function','return'].map(name=>method('keyword.'+name,name,[],v=>v)).concat([method('operator.multiply','*',[2],(v,a)=>v*(a[0]==='PI'?Math.PI:a[0]))])
export const methods = Object.fromEntries(categories.flatMap(c=>c.methods.map(m=>[m.id,m])).concat(keywords.map(m=>[m.id,m])))
export function execute(id, value, args) {
  const m=methods[id]
  if(!m || id.startsWith('source.'))throw new Error('未知方法')
  if(!Array.isArray(args))throw new Error('方法参数必须是 JSON 数组')
  return m.run(value,args)
}
export function format(value) {
  if(typeof value==='number'&&!Number.isFinite(value))return String(value)
  if(value===undefined)return 'undefined'
  return JSON.stringify(value)
}
